import { trackCartActions } from 'features/cart';
import { updateUtagData, utagViewArtificialPageView } from 'features/tealium';
import { getPromoCodeFieldValidationMessage } from 'apps/cart/api/utilities';
import { getCartDataFromUtag, trackCartUpdates } from 'features/monetate';
import { setGenericEvent } from 'features/tealium/ga4/custom';

import { cart, cartModel } from '../config';
import CartBaseItemView from '../../baseViews/ItemView';
import { UpdateCartPromoCode, DeleteCartPromoCode } from '../../api';
import AddPromoCodeTemplate from '../templates/AddPromoCodeTemplate';

const trackArtificialPageView = utagViewArtificialPageView();
const promoCodeCartSiteMode = [ 'none', 'consumer', 'professional', 'employee' ].includes(
	window.utag_data.user_type.toLowerCase()
);

const AddPromoCode = CartBaseItemView.extend({
	JSXTemplate: AddPromoCodeTemplate,
	className: 'addPromoCodeContainer',
	ui: {
		promoInput: '.promoInput',
		updatePromo: '.promoButton',
		promoCodeError: '.promoCodeError',
		promoCodeErrorMessage: '#promoCodeInput-error'
	},
	events: {
		'keypress @ui.promoInput': 'onEnterSubmit',
		'keyup @ui.promoInput': 'resetCouponCode',
		'click @ui.updatePromo': 'updatePromo'
	},
	initialize () {

		this.listenTo(this.model, 'change', this.render, this);

	},
	onDomRefresh () {

		if (this.model.get('SelectedPromoCode')) {

			this.$el.parent().addClass('hidden');

		} else {

			this.$el.parent().removeClass('hidden');

		}

	},
	onEnterSubmit (e) {

		if (e.keyCode === 13) {

			this.updatePromo(e);
			return false;

		}
		return true;

	},
	resetCouponCode (e) {

		e.preventDefault();
		if (!this.ui.promoInput.val()) {

			this.ui.promoInput.removeClass('error');
			this.ui.promoCodeError.addClass('hidden');

		}

	},
	updatePromo (e) {

		e.preventDefault();

		const code = $.trim(this.ui.promoInput.val());

		if (code) {

			const request = UpdateCartPromoCode(code).then((response) => {

				const promoCodeError = getPromoCodeFieldValidationMessage(
					response.GlobalCartResponseModel.CalculatorResults
				);
				if (promoCodeError.length > 0) {

					const deleteRequest = DeleteCartPromoCode().then((deleteResponse) => {

						if (deleteResponse.operationSuccess) {

							this.ui.promoInput.addClass('error');
							this.ui.promoInput.focus();
							this.ui.promoCodeError.removeClass('hidden');
							this.ui.promoCodeErrorMessage.text(promoCodeError);

						} else {

							this.ui.promoCodeErrorMessage.text(deleteResponse);

						}

					});
					$(cart).trigger('indicateLoad', deleteRequest);
					trackCartActions({
						event_action: 'Error-Coupon',
						event_label: `${promoCodeError.replace('.', '')}-${code}`
					});

					if (promoCodeCartSiteMode) {

						setGenericEvent({
							event_name: 'cart_promo_add_error',
							promocode: promoCodeError.replace('.', ''),
							promocode_value: code,
							error_message: `${promoCodeError.replace('.', '')} - ${code}`
						});

					}

				} else {

					updateUtagData(response.GlobalCartResponseModel.TealiumTagData);
					// Monetate AJAX update (retrack)
					trackCartUpdates(getCartDataFromUtag());

					cartModel.update(response);
					const promoCodeVal = document.querySelector('.promoCodeLine>.fr.osValue');
					if (promoCodeVal) {

						const promoDisc = promoCodeVal.innerText.replace(/\$|-/g, '').trim();
						trackCartActions({
							event_action: 'Success-Apply-Coupon-Code',
							event_label: `${code}-${promoDisc}`
						});

						if (promoCodeCartSiteMode) {

							setGenericEvent({
								event_name: 'cart_promo_add_success',
								promocode: 'promo code customer applies successfully',
								promocode_value: code
							});

						}

					}

				}

			});
			$(cart).trigger('indicateLoad', request);

		} else {

			this.ui.promoInput.focus();
			trackCartActions({
				event_action: 'click-NoApply-Coupon-Code'
			});

			if (promoCodeCartSiteMode) {

				setGenericEvent({
					event_name: 'cart_promo_add_error',
					promocode: 'no code entered',
					error_message: 'no code entered'
				});

			}

		}

	}
});

export default AddPromoCode;
